import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import { useStores } from "../../core/stores";
import BusinessPlanScreen from "./BusinessPlanScreen";
import { BusinessPlanSettingsUI } from "./tabs/settings/BusinessPlanSettingsUI";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "BusinessSettings"
>;

export const BusinessPlanSettingsScreen = observer((props: Props) => {
  const { businessPlansStore } = useStores();

  const businessPlan = businessPlansStore.byId.get(
    props.route.params.businessUid,
  );

  return (
    <BusinessPlanScreen {...props} hideMenu>
      {businessPlan ? (
        <BusinessPlanSettingsUI businessPlan={businessPlan} />
      ) : null}
    </BusinessPlanScreen>
  );
});
